import React, {useEffect, useRef} from "react";
import {shouldOpenSharedSection} from "../../navigation/useSharedReport";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

/**
 * Shared collapsible header button with optional right-side interactive slot.
 *
 * rightSlot:
 * - If provided, it is rendered as-is (dropdowns/buttons etc.)
 * - We DO NOT apply pointer-events-none to rightSlot so it remains clickable.
 *
 * You can also pass className to override/extend styling if needed.
 */
export function HeaderToggleButton({
  isOpen,
  onToggle,
  title,
  ariaLabel,
  controlsId,
  reportNavigation = false,
  rightSlot = null,
  className = "",
}) {
  const restored = useRef(false);
  useEffect(() => {
    if (!restored.current && shouldOpenSharedSection(controlsId)) {
      restored.current = true;
      if (!isOpen) onToggle();
    }
  }, [controlsId, isOpen, onToggle]);
  const headerBtnClass =
    "w-full bg-gray-100 border border-gray-200 rounded min-h-10 flex flex-wrap gap-2 items-center justify-between text-left text-gray-900 hover:bg-gray-200 pl-2 pr-1 py-1";

  return (
    <div
      id={reportNavigation ? `${controlsId}-heading` : undefined}
      data-report-title={reportNavigation ? title : undefined}
      className={`${headerBtnClass} ${className} scroll-mt-24`.trim()}
    >
    <button
      type="button"
      onClick={onToggle}
      className="min-w-0 flex-1 bg-transparent text-left text-inherit"
      aria-label={ariaLabel}
      aria-expanded={isOpen}
      aria-controls={controlsId}
      data-shared-toggle={controlsId}
    >
      <h3 className="text-lg font-semibold leading-tight flex items-center h-full text-gray-900">
        {title}
      </h3>
    </button>

      {rightSlot ? (
        <span className="ml-auto h-full inline-flex items-center justify-end shrink-0">
          {rightSlot}
        </span>
      ) : (
        <button type="button" onClick={onToggle} aria-label={isOpen ? 'Collapse section' : 'Expand section'} aria-expanded={isOpen} className="h-full w-12 inline-flex items-center justify-center shrink-0 bg-transparent text-gray-600">
          {isOpen ? (
            <ChevronDownIcon className="w-5 h-5" />
          ) : (
            <ChevronRightIcon className="w-5 h-5" />
          )}
        </button>
      )}
    </div>
  );
}
